import type { OnboardingBrowserRuntime } from '../common/services/onboarding-browser-runtime';

/** FTO Pro 首页首次引导需要的浏览器运行时能力。 */
export interface FtoProOnboardingRuntime extends OnboardingBrowserRuntime {
    /** 获取当前登录账号 ID；账号不存在时返回空字符串。 */
    getIdentityId(): Promise<string>;
    /** 判断当前用户是否已登录。 */
    isUserLogin(): Promise<boolean>;
}

/** FTO Pro 首页首次引导 runtime 的容器标识。 */
export const FtoProOnboardingRuntime = Symbol('FtoProOnboardingRuntime');
